// const {store} =  require("../../store");
// const {state} =  require("../../store/modules/candidateVUEX");
const {
	required,
	maxLength,
	minLength,
	between,
	requiredIf,
	requiredUnless,
	email,
	helpers,
} = require("vuelidate/lib/validators");

const basicDetailsValidationsNewUser = (context, states) => {
	let state = context.allValidation.personalDetails;
	console.log(state.keys.displayEmail);
	return {
		profile: {
			firstName: {
				required: requiredIf(function () {
					return state.keys.firstName.isMandatory;
				}),

				alphawithDot: (value) => {
					if (value === null) return true;
					return /^[a-zA-Z. ]+$/.test(value);
				},
				// maxLength: maxLength(
				//   state.keys.firstName.charlimit != null
				//     ? state.keys.firstName.charlimit
				//     : null
				// ),
				maxLength: (value) => {
					if (value === null) return true; // Handle null value
					if (state.keys.firstName.charlimit === null) return true; // Allow any length if charlimit is null
					return value.length <= state.keys.firstName.charlimit;
				},
			},
			// middleName: {
			//   required: requiredIf(() => {
			//     return state.keys.middleName.isMandatory;
			//   }),
			//   alphawithDot: (value) => {
			//     if (value === null || value === "") return true;
			//     return /^[a-zA-Z. ]+$/.test(value);
			//   },
			//   maxLength: (value) => {
			//     if (value === null) return true;
			//     if (state.keys.middleName.charlimit === null) return true;
			//     return value.length <= state.keys.middleName.charlimit;
			//   },
			// },
			lastName: {
				required: requiredIf(function () {
					return state.keys.lastName.isMandatory;
				}),
				alphawithDot: (value) => {
					if (value === null) return true;
					return /^[a-zA-Z. ]+$/.test(value);
				},
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.lastName.charlimit === null) return true;
					return value.length <= state.keys.lastName.charlimit;
				},
			},
			displayEmail: {
				required: requiredIf(function () {
					return state.keys.displayEmail.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.displayEmail.charlimit === null) return true;
					return value.length <= state.keys.displayEmail.charlimit;
				},
				alphaEmail: (value) => {
					if (value === null) return true;
					return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(value);
					// return /^(?:[^A-Z<>()[\]\\.,;:\s@"]+(\.[^A-Z<>()[\]\\.,;:\s@"]+)*)|(".+")@(?:\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(?:([a-z0-9]+\.)+[a-z]{2,})$/.test(value);
				},
				email,
			},
			countryCode: {
				required: requiredIf(function () {
					return state.keys.countryCode.isMandatory;
				}),
			},
			phoneNumber: {
				required: requiredIf(function () {
					return state.keys.phoneNumber.isMandatory;
				}),
				// minLength: minLength(
				//   state.keys.phoneNumber.charlimit != null
				//     ? state.keys.phoneNumber.charlimit
				//     : 0
				// ),

				//   minLength:  function() {
				//     return minLength(state.keys.phoneNumber.charlimit);
				// },

				// alpha: helpers.regex("alpha", /^[6-9]{1}[0-9]{9}$/)
			},
			altCountryCode: {
				required: requiredIf(function () {
					return state.keys.altCountryCode.isMandatory;
				}),
			},
			altPhoneNumber: {
				required: requiredIf(function () {
					return state.keys.altPhoneNumber.isMandatory;
				}),
				// minLength: minLength(
				//   state.keys.altPhoneNumber.charlimit != null
				//     ? state.keys.altPhoneNumber.charlimit
				//     : 0
				// ),
				// alpha: helpers.regex("alpha", /^[6-9]{1}[0-9]{9}$/)
			},

			city: {
				required: requiredIf(function () {
					return state.keys.city.isMandatory;
				}),
				// alpha: helpers.regex("alpha", /^[0-9A-Za-z\s ]*$/),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.city.charlimit === null) return true;
					return value.length <= state.keys.city.charlimit;
				},
			},
			designation: {
				required: requiredIf(function () {
					return state.keys.designation.isMandatory;
				}),
				// allAlphaWithSpace: (value) => {
				//   if (value === null) return true;
				//   return /^(?=(?:.*[a-zA-Z]))[a-zA-Z0-9 !@#$%^&*()_+\-=\[\]{};:'"\\|,.<>\/?]*$/.test(value)          ;
				// },
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.designation.charlimit === null) return true;
					return value.length <= state.keys.designation.charlimit;
				},
			},
			experienceLevel: {
				required: requiredIf(function () {
					return state.keys.experienceLevel.isMandatory;
				}),
			},
			industry: {
				required: requiredIf(function () {
					return state.keys.industry.isMandatory;
				}),
			},
			profileSummary: {
				required: requiredIf(function () {
					return state.keys.profileSummary.isMandatory;
				}),
			},
		},
	};
};
const basicDetailsValidationsNewPart2 = (context, states) => {
	let state = context.allValidation.demographics;
	return {
		maritalStatus: {
			required: requiredIf(function () {
				return state.keys.maritalStatus.isMandatory;
			}),
		},
		totalYearsOfExp: {
			required: requiredIf(function () {
				return state.keys.totalYearsOfExp.isMandatory;
			}),
			between: between(0, 99),
			// decimal: helpers.regex("decimal", /^[1-9]\d*(\.(0?[1-9]|1[0-1]))?$|^0\.(0?[1-9]|1[0-1])$/)
			decimal: helpers.regex("decimal", /^(0|[1-9]\d*)(\.\d+)?$|^0\.\d+$/),
		},
		currentCTC: {
			required: requiredIf(function () {
				return state.keys.currentCTC.isMandatory;
			}),
			between: between(0, 99),
			alpha: helpers.regex(
				"alpha",
				/^(0|0?\d|0?\d\.\d{1,2}|[1-9]\d?|99)(\.\d{1,2})?$/
			),
		},
		expectedCTC: {
			required: requiredIf(function () {
				return state.keys.expectedCTC.isMandatory;
			}),
			between: between(0, 99),
			alpha: helpers.regex(
				"alpha",
				/^(0|0?\d|0?\d\.\d{1,2}|[1-9]\d?|99)(\.\d{1,2})?$/
			),
		},
		nationality: {
			required: requiredIf(function () {
				return state.keys.nationality.isMandatory;
			}),
		},
		dateOfBirth: {
			required: requiredIf(function () {
				return state.keys.dateOfBirth.isMandatory;
			}),
		},
		willingToRelocateTo: {
			required: requiredIf(function () {
				return state.keys.willingToRelocateTo.isMandatory;
			}),
		},

		languages: {
			required: requiredIf(function () {
				return state.keys.languages.isMandatory;
			}),
		},
		noticePeriod: {
			required: requiredIf(function () {
				return state.keys.noticePeriod.isMandatory;
			}),
		},
		gender: {
			required: requiredIf(function () {
				return state.keys.gender.isMandatory;
			}),
		},
		workType: {
			required: requiredIf(function () {
				return state.keys.workType.isMandatory;
			}),
		},
		currentAddress: {
			required: requiredIf(function () {
				return state.keys.currentAddress.isMandatory;
			}),
			maxLength: (value) => {
				if (value === null) return true;
				if (state.keys.currentAddress.charlimit === null) return true;
				return value.length <= state.keys.currentAddress.charlimit;
			},
		},
		permanentAddress: {
			required: requiredIf(function () {
				return state.keys.permanantAddress.isMandatory;
			}),
			// maxLength: maxLength(
			//   state.keys.permanantAddress.charlimit != null &&
			//     !context.sameAsCurrentAddress
			//     ? state.keys.permanantAddress.charlimit
			//     : null
			// ),
			maxLength: (value) => {
				if (value === null) return true;
				if (state.keys.permanantAddress.charlimit === null) return true;
				if (state.keys.permanantAddress.charlimit != null)
					return value.length <= state.keys.permanantAddress.charlimit;
			},
		},
	};
};
const educationValidations = (context) => {
	let state = context.allValidation.education;
	return {
		education: {
			institute: {
				// required,
				required: requiredIf(function () {
					return state.keys.institute.isMandatory;
				}),

				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.institute.charlimit === null) return true;
					return value.length <= state.keys.institute.charlimit;
				},
			},
			qualification: {
				// required,
				required: requiredIf(function () {
					return state.keys.qualification.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.qualification.charlimit === null) return true;
					return value.length <= state.keys.qualification.charlimit;
				},
			},
			degree: {
				// required,
				required: requiredIf(function () {
					return state.keys.degree.isMandatory;
				}),
				maxLength: (value) => {
					if ((value && value === null) || value == undefined) return true;
					if (state.keys.degree.charlimit === null) return true;
					return value.length <= state.keys.degree.charlimit;
				},
				alpha: helpers.regex("alpha", /[^0-9]+$/),
			},
			fieldOfStudy: {
				// required,
				required: requiredIf(function () {
					return state.keys.fieldOfStudy.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.fieldOfStudy.charlimit === null) return true;
					return value.length <= state.keys.fieldOfStudy.charlimit;
				},
			},
			location: {
				// required,
				required: requiredIf(function () {
					return state.keys.location.isMandatory;
				}),
				// alpha: helpers.regex("alpha", /^[0-9A-Za-z\s ]*$/),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.location.charlimit === null) return true;
					return value.length <= state.keys.location.charlimit;
				},
			},
			gradePercentage: {
				// required,
				required: requiredIf(function () {
					return (
						state.keys.gradePercentage.isMandatory &&
						!context.education.currentEducation
					);
				}),
				between: between(0, 100),
				alpha: helpers.regex("alpha", /^[0-9.]+$/),
			},

			// yearOfJoining: {
			//   required,
			// },
			// yearOfPassout: {
			//   required: requiredIf(function () {
			//     return context.education.currentEducation == false;
			//   }),
			// },
			courseDuration: {
				// required,
				required: requiredIf(function () {
					return (
						state.keys.courseDuration.isMandatory &&
						context.education.qualification != "10th" &&
						context.education.qualification != "12th"
					);
				}),
				alpha: helpers.regex("alpha", /^[0-9.]+$/),
			},
		},
	};
};

const experienceValidations = (context, states) => {
	let state = context.allValidation.experience;
	return {
		experience: {
			designation: {
				// required
				required: requiredIf(function () {
					return state.keys.designation.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.designation.charlimit === null) return true;
					return value.length <= state.keys.designation.charlimit;
				},
			},
			companyName: {
				// required
				required: requiredIf(function () {
					return state.keys.companyName.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.companyName.charlimit === null) return true;
					return value.length <= state.keys.companyName.charlimit;
				},
				// maxLength: maxLength(
				//   state.keys.companyName.charlimit != null
				//     ? state.keys.companyName.charlimit
				//     : null
				// ),
			},
			jobType: {
				// required
				required: requiredIf(function () {
					return state.keys.jobType.isMandatory;
				}),
			},
			location: {
				// required
				required: requiredIf(function () {
					return state.keys.location.isMandatory;
				}),
				// alpha: helpers.regex("alpha", /^[0-9A-Za-z\s ]*$/),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.location.charlimit === null) return true;
					return value.length <= state.keys.location.charlimit;
				},
			},
			startDate: {
				// required
				required: requiredIf(function () {
					return state.keys.startDate.isMandatory;
				}),
			},
			endDate: {
				// required
				required: requiredIf(function () {
					return (
						!context.experience.currentExperience &&
						state.keys.endDate.isMandatory
					);
				}),
			},
			highlight: {
				// required
				required: requiredIf(function () {
					return state.keys.highlight.isMandatory;
				}),
			},
		},
	};
};

const skillsValidations = (context, states) => {
	let stateSkill = context.allValidation.skills;
	let stateInterSkill = context.allValidation.interpersonalSkills;
	return {
		skill: {
			skillName: {
				required: requiredIf(function () {
					return stateSkill.keys.skillName.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true;
					if (stateSkill.keys.skillName.charlimit === null) return true;
					return value.length <= stateSkill.keys.skillName.charlimit;
				},
				alpha: helpers.regex("alpha", /^[^,]*$/),
			},
			expertiseLevel: {
				required: requiredIf(function () {
					return stateSkill.keys.expertiseLevel.isMandatory;
				}),
			},
			yearsOfExp: {
				required: requiredIf(function () {
					return stateSkill.keys.yearsOfExp.isMandatory;
				}),
				alpha: helpers.regex(
					"alpha",
					// /^(0|0?\d|0?\d\.\d|0?\d\.\d{1}|[1-9]\d?|99)(\.\d)?$/    // DON'T DELETE
					/^(0|0?\d|0?\d\.\d|0?\d\.\d{1,2}|[1-9]\d?|99)(\.\d{1,2})?$/
				),
			},
		},

		interpersonalSkill: {
			skillName: {
				required: requiredIf(function () {
					return stateInterSkill.keys.skillName.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true;
					if (stateInterSkill.keys.skillName.charlimit === null) return true;
					return value.length <= stateInterSkill.keys.skillName.charlimit;
				},
				alpha: helpers.regex("alpha", /^[A-Za-z\s]*$/),
			},
			expertiseLevel: {
				required: requiredIf(function () {
					return stateInterSkill.keys.expertiseLevel.isMandatory;
				}),
			},
		},
	};
};

const domainValidations = () => {
	return {
		domain: {
			title: {
				required,
			},
			expertiseLevel: {
				required,
			},
			yearsOfExp: {
				required,
				alpha: helpers.regex("alpha", /^[0-9]+(\.[0-9]+)?$/),
			},
			description: {
				required,
			},
		},
	};
};

const achievementValidations = (context) => {
	let state = context.allValidation.achievement;
	let tempAchieveType = context.achievement.achieveType;
	return {
		achievement: {
			achieveType: {
				required: requiredIf(function () {
					return (
						state.keys.award.achieveType.isMandatory ||
						state.keys.certificate.achieveType.isMandatory ||
						state.keys.event.achieveType.isMandatory
					);
				}),
			},
			title: {
				required: requiredIf(function () {
					return tempAchieveType == "award"
						? state.keys.award.title.isMandatory
						: tempAchieveType == "certificate"
						? state.keys.certificate.title.isMandatory
						: state.keys.event.title.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true; // Handle null value

					// Determine which charlimit to use based on the condition for required
					const charlimit =
						tempAchieveType === "award"
							? state.keys.award.title.charlimit
							: tempAchieveType === "certificate"
							? state.keys.certificate.title.charlimit
							: state.keys.event.title.charlimit;

					if (charlimit === null) return true; // Allow any length if charlimit is null
					return value.length <= charlimit;
				},
			},
			issuingOrganization: {
				required: requiredIf(function () {
					return tempAchieveType == "award" &&
						state.keys.award.issuingOrganization
						? state.keys.award.issuingOrganization.isMandatory
						: tempAchieveType == "certificate" &&
						  state.keys.award.issuingOrganization
						? state.keys.certificate.issuingOrganization.isMandatory
						: tempAchieveType == "event" && state.keys.event.issuingOrganization
						? state.keys.event.issuingOrganization.isMandatory
						: false;
				}),
				maxLength: (value) => {
					if (value === null) return true; // Handle null value
					const charlimit =
						tempAchieveType === "award"
							? state.keys.award.issuingOrganization.charlimit
							: tempAchieveType === "certificate"
							? state.keys.certificate.issuingOrganization.charlimit
							: state.keys.event.issuingOrganization.charlimit; // No charlimit specified

					if (charlimit === null) return true; // Allow any length if charlimit is null
					return value.length <= charlimit;
				},
			},
			certificateID: {
				// alpha: helpers.regex("alpha", /^[a-zA-Z0-9]+$/)
				maxLength: (value) => {
					if (value === null) return true; // Handle null value
					const charlimit =
						tempAchieveType === "certificate"
							? state.keys.certificate.certificateID.charlimit
							: null; // No charlimit specified

					if (charlimit === null) return true; // Allow any length if charlimit is null
					return value.length <= charlimit;
				},
			},
			issueDate: {
				required: requiredIf(function () {
					return tempAchieveType == "award" && state.keys.award.issueDate
						? state.keys.award.issueDate.isMandatory
						: tempAchieveType == "certificate" && state.keys.award.issueDate
						? state.keys.certificate.issueDate.isMandatory
						: tempAchieveType == "event" && state.keys.event.issueDate
						? state.keys.event.issueDate.isMandatory
						: false;
				}),
			},
			expirationDate: {
				required: requiredIf(function () {
					return tempAchieveType == "award" && state.keys.award.expirationDate
						? state.keys.award.expirationDate.isMandatory
						: tempAchieveType == "certificate" &&
						  state.keys.award.expirationDate
						? state.keys.certificate.expirationDate.isMandatory
						: tempAchieveType == "event" && state.keys.event.expirationDate
						? state.keys.event.expirationDate.isMandatory
						: false;
				}),
			},
			usedSkills: {
				required: requiredIf(function () {
					return tempAchieveType == "award" && state.keys.award.usedSkills
						? state.keys.award.usedSkills.isMandatory
						: tempAchieveType == "certificate" && state.keys.award.usedSkills
						? state.keys.certificate.usedSkills.isMandatory
						: tempAchieveType == "event" && state.keys.event.usedSkills
						? state.keys.event.usedSkills.isMandatory
						: false;
				}),
			},
			link: {
				required: requiredIf(function () {
					return tempAchieveType == "award" && state.keys.award.link
						? state.keys.award.link.isMandatory
						: tempAchieveType == "certificate" && state.keys.award.link
						? state.keys.certificate.link.isMandatory
						: tempAchieveType == "event" && state.keys.event.link
						? state.keys.event.link.isMandatory
						: false;
				}),
				maxLength: (value) => {
					if (value === null) return true; // Handle null value
					const charlimit =
						tempAchieveType === "award"
							? state.keys.award.link.charlimit
							: tempAchieveType === "certificate"
							? state.keys.certificate.link.charlimit
							: null; // No charlimit specified

					if (charlimit === null) return true; // Allow any length if charlimit is null
					return value.length <= charlimit;
				},
			},
			description: {
				required: requiredIf(function () {
					return tempAchieveType == "award" && state.keys.award.description
						? state.keys.award.description.isMandatory
						: tempAchieveType == "certificate" && state.keys.award.description
						? state.keys.certificate.description.isMandatory
						: tempAchieveType == "event" && state.keys.event.description
						? state.keys.event.description.isMandatory
						: false;
				}),
				maxLength: (value) => {
					if (value === null) return true; // Handle null value

					// Determine which charlimit to use based on the condition for required
					const charlimit =
						tempAchieveType === "award"
							? state.keys.award.description.charlimit
							: tempAchieveType === "certificate"
							? state.keys.certificate.description.charlimit
							: tempAchieveType == "event" && state.keys.event.description
							? state.keys.event.description.charlimit
							: null;

					if (charlimit === null) return true; // Allow any length if charlimit is null
					return value.length <= charlimit;
				},
			},
		},
	};
};

const saveResumeValidation = (context) => {
	return {
		resumeName: {
			required,
			maxLength: 20,
		},
	};
};
const saveResumeclinicValidation = (context) => {
	return {
		parserProfileinput: {
			required,
			maxLength: 20,
		},
	};
};

const projectValidations = (context, states) => {
	let state = context.allValidation.project;
	return {
		project: {
			title: {
				required: requiredIf(function () {
					return state.keys.title.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.title.charlimit === null) return true;
					return value.length <= state.keys.title.charlimit;
				},
			},
			role: {
				required: requiredIf(function () {
					return state.keys.role.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.role.charlimit === null) return true;
					return value.length <= state.keys.role.charlimit;
				},
			},
			domain: {
				required: requiredIf(function () {
					return state.keys.domain.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.domain.charlimit === null) return true;
					return value.length <= state.keys.domain.charlimit;
				},
			},
			skillsUsed: {
				required: requiredIf(function () {
					return state.keys.skillsUsed.isMandatory;
				}),
			},
			startDate: {
				required: requiredIf(function () {
					return state.keys.startDate.isMandatory;
				}),
			},
			endDate: {
				required: requiredIf(function () {
					return (
						!context.project.currentProject && state.keys.endDate.isMandatory
					);
				}),
			},
			client: {
				required: requiredIf(function () {
					return state.keys.client.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.client.charlimit === null) return true;
					return value.length <= state.keys.client.charlimit;
				},
			},
			association: {
				required: requiredIf(function () {
					return state.keys.associatedWith.isMandatory;
				}),
			},
			description: {
				required: requiredIf(function () {
					return state.keys.description.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.description.charlimit === null) return true;
					return value.length <= state.keys.description.charlimit;
				},
			},

			responsibility: {
				required: requiredIf(function () {
					return state.keys.responsibility.isMandatory;
				}),
			},
			summary: {
				required: requiredIf(function () {
					return state.keys.summary.isMandatory;
				}),
				maxLength: (value) => {
					if (value === null) return true;
					if (state.keys.summary.charlimit === null) return true;
					return value.length <= state.keys.summary.charlimit;
				},
			},
		},
	};
};

const portfolioValidations = (context) => {
	let state = context.allValidation.portfolio;
	return {
		portfolioName: {
			required: requiredIf(function () {
				return state.keys.portfolioName.isMandatory;
			}),
		},
		websiteName: {
			required: requiredIf(function () {
				return (
					state.keys.websiteName.isMandatory || context.portfolioName == "other"
				);
			}),
			maxLength: (value) => {
				if (value === null) return true; // Handle null value
				if (state.keys.websiteName.charlimit === null) return true; // Allow any length if charlimit is null
				return value.length <= state.keys.websiteName.charlimit;
			},
		},
		portfolioLink: {
			required: requiredIf(function () {
				return (
					state.keys.portfolioLink.isMandatory || context.portfolioName != null
				);
			}),
			maxLength: (value) => {
				if (value === null) return true; // Handle null value
				if (state.keys.portfolioLink.charlimit === null) return true; // Allow any length if charlimit is null
				return value.length <= state.keys.portfolioLink.charlimit;
			},
			alpha: helpers.regex(
				"alpha",
				// /\b(?:https?:\/\/|www\.)\S+/gi
				// /^(https?|ftp):\/\/[^\s\/$.?#].[^\s]*$/
				/^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+(\S+)?$/
			),
		},
	};
};
const hobyValidations = (context) => {
	let state = context.allValidation.hobbies;
	return {
		hobyName: {
			required: requiredIf(function () {
				return state.keys.isMandatory;
			}),
			maxLength: (value) => {
				if (value === null) return true; // Handle null value
				if (state.keys.charlimit === null) return true; // Allow any length if charlimit is null
				return value.length <= state.keys.charlimit;
			},
			alphaWithSpace: (value) => {
				if (value === null) return true;
				return /^(?=(?:.*[a-zA-Z]))[a-zA-Z0-9 !@#$%^&*()_+\-=\[\]{};:'"\\|,.<>\/?]*$/.test(
					value
				);
			},
		},
	};
};

const resumeValidations = (context) => {
	return {
		resumeName: {
			required,
			maxLength: maxLength(20),
		},
		selectedPrimaryOption: {
			required,
		},
	};
};

// const profileValidations = () => {
//   return {
//     profile: {
//       firstName: {
//         required,
//       },
//       lastName: {
//         required,
//       },
//       email: {
//         required,
//       },
//       city: {
//         required,
//       },
//       headline: {
//         required,
//         maxLength: maxLength(128),
//       },
//       profileSummary: {
//         required,
//       },
//       designation: {
//         required,
//         maxLength: maxLength(64),
//       },
//     },
//   };
// };
module.exports = {
	// basicDetailsValidations,
	educationValidations,
	experienceValidations,
	skillsValidations,
	domainValidations,
	achievementValidations,
	projectValidations,
	portfolioValidations,
	// profileValidations,
	hobyValidations,
	basicDetailsValidationsNewUser,
	basicDetailsValidationsNewPart2,
	saveResumeValidation,
	resumeValidations,
	saveResumeclinicValidation
};
